var React = require('react');

function ManifestoLogo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},[React.createElement("style",{"key":0},".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:none;stroke:#fff;stroke-miterlimit:10;}"),React.createElement("clipPath",{"id":"a","key":1},React.createElement("rect",{"className":"a","width":"440","height":"358","transform":"translate(609 1627)"}))]),React.createElement("g",{"className":"b","transform":"translate(-609 -1627)","key":1},React.createElement("g",{"transform":"translate(362 1111.437)"},React.createElement("g",{"transform":"translate(0 570.896)"},React.createElement("path",{"className":"c","d":"M279.151,687.676l73.312,126.981L216.686,946.208h0l98.928,171.348L631.228,570.9H0l98.929,171.35Z","transform":"translate(0 -570.896)"}))))]);
}

ManifestoLogo.defaultProps = {"width":"440","height":"358","viewBox":"0 0 440 358"};

module.exports = ManifestoLogo;

ManifestoLogo.default = ManifestoLogo;
